import * as React from "react"
import { useTheme } from "@mui/material"
import { Toaster } from "react-hot-toast"

// this technically isn't a provider since it doesn't use context, but can sort of think about it in the same way
export default function ToastProvider() {
  const theme: any = useTheme()
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        className: "hot-toast",
        style: {
          color: theme.palette.gray["600"],
          fontSize: theme.typography.md,
          alignItems: "flex-start",
          boxShadow: theme.shadows[3],
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.gray["200"],
        },
        success: {
          iconTheme: {
            primary: theme.palette.green["50"],
            secondary: theme.palette.green["500"],
          },
        },
        error: {
          iconTheme: {
            primary: theme.palette.red["50"],
            secondary: theme.palette.red["500"],
          },
        },
      }}
    />
  )
}
